const oneTime = document.querySelector('[js-one-time-plan]');
const subscribe = document.querySelector('[js-subscription-plan]');
const details = document.querySelector('[js-subscribe-details]');
const select = document.querySelector('[js-subscription-widget-select]');


function toggleDetails() {

  if (subscribe.checked) {
    details.classList.add("subscription-widget__details--active");
    select.setAttribute("name", "selling_plan");
  } else {
    details.classList.remove("subscription-widget__details--active");
    select.removeAttribute("name");
  }


  updateAddToCartPrices();
}


function parseAmount(text) {
  const numeric = parseFloat(text.replace(/[^\d.]/g, ''));
  return isNaN(numeric) ? 0 : numeric;
}

function updateAddToCartPrices() {
  const subscriptionDiscountedPriceEl = document.querySelector('[js-subscription-discounded-price]');
  const subscriptionRegularPriceEl = document.querySelector('[js-subscription-regular-price]');
  const oneTimePriceEl = document.querySelector('[js-one-time-price]');
  const oneTimeComparePriceEl = document.querySelector('[js-one-time-compare-price]');

  // Variant compare-at price; empty when the variant is not on sale
  const oneTimeCompare = oneTimeComparePriceEl ? oneTimeComparePriceEl.textContent.trim() : '';
  const subscriptionPrice = subscriptionDiscountedPriceEl ? subscriptionDiscountedPriceEl.textContent.trim() : '';

  // On variant change the theme JS can write "£0" (no compare-at on the
  // selling plan) or a price equal to the subscription price into the
  // widget's strike-out; blank it out in both cases
  if (subscriptionRegularPriceEl) {
    const regularPrice = subscriptionRegularPriceEl.textContent.trim();
    const regularAmount = parseAmount(regularPrice);
    if (regularPrice && (regularAmount === 0 || regularAmount <= parseAmount(subscriptionPrice))) {
      subscriptionRegularPriceEl.textContent = '';
    }
  }

  let newPrice = '';
  let comparePrice = '';

  if (subscribe.checked) {
    newPrice = subscriptionPrice;
    comparePrice = oneTimeCompare || (subscriptionRegularPriceEl ? subscriptionRegularPriceEl.textContent.trim() : '');
  } else {
    newPrice = oneTimePriceEl ? oneTimePriceEl.textContent.trim() : '';
    comparePrice = oneTimeCompare;
  }

  // Never strike out nothing, zero, or the same amount the customer pays
  if (!comparePrice || parseAmount(comparePrice) === 0 || parseAmount(comparePrice) <= parseAmount(newPrice)) {
    comparePrice = '';
  }

  // Update every simple price render (buy-box button, sticky ATC bar);
  // the theme's variant-change JS only refreshes compare-at inside the form,
  // so the sticky bar's copy would otherwise go stale
  if (newPrice) {
    document.querySelectorAll('[data-product-price]').forEach(function (el) {
      el.textContent = newPrice;
    });
  }

  document.querySelectorAll('[js-compare-at-price]').forEach(function (el) {
    // An empty <s> renders nothing, so visibility is driven by content
    el.textContent = comparePrice;
    el.style.removeProperty('display');
  });
}

oneTime.addEventListener("change", toggleDetails);
subscribe.addEventListener("change", toggleDetails);

// The theme's variant-change JS rewrites the widget prices; re-sync the
// add-to-cart button whenever that happens
const widgetPriceObserver = new MutationObserver(updateAddToCartPrices);
[
  '[js-one-time-price]',
  '[js-one-time-compare-price]',
  '[js-subscription-discounded-price]',
  '[js-subscription-regular-price]',
].forEach(function (selector) {
  const el = document.querySelector(selector);
  if (el) {
    widgetPriceObserver.observe(el, { childList: true, characterData: true, subtree: true });
  }
});

toggleDetails();
